import React, { useState } from 'react'
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend, LabelList, BarChart, Bar } from 'recharts';
import CustomDropDown from '../../../components/CustomDropDown';
import { _ToNormal, AuthConsole } from '../../../Utils/helper';
import ShimmerLoader from '../../../components/ShimmerLoader';

export default function Charts({ data, keyList, getDashData, loading }) {
    // const data = [{ day: '01 Apr', 'Reliving Letter': 30, 'Offer Letter': 32 }, { day: '02 Apr', 'Reliving Letter': 40, 'Offer Letter': 30 }, { day: '03 Apr', 'Reliving Letter': 70, 'Offer Letter': 80 }];
    const [credentialType, setCredentialType] = useState('Show All')
    const [documentType, setDocumentType] = useState('All Documents')
    const [timePeriod, setTimePeriod] = useState('Last 30 days')
    const strokeColor = {
        0: "#005df0",
        1: "#fcb992",
        2: '#D20062',
        3: '#00224D',
        4: '#00224D'

    }
    const filterMap = {
        'All Documents': '',
        'Issued': 'PUBLISHED',
        'Draft': 'DRAFT',
        'Revoked': 'REVOKED',
        'Last 7 days': 7,
        'Last 30 days': 30,
        'Last 90 days': 90
    }
    function handleDocumentChange(e) {
        setDocumentType(e)
        getDashData(filterMap[e], filterMap[timePeriod], true)
    }
    function handleTimeChange(e) {
        setTimePeriod(e)
        getDashData(filterMap[documentType], filterMap[e], true)

    }


    const graphData = Object.keys(data).map((key) => ({
        name: key.replace(/_/g, " "), // Label on X-axis
        count: data[key], // Y-axis value
      }))

      AuthConsole(keyList);
      
      
    return (
        <div className='chart-container'>
            <div className='chart-header'>
                <div className='chart-header-left'>
                    <span className='chat-header-title'>Credentials</span>
                    {/* <CustomDropDown list={['Show All', 'Issued']} selectedOption={credentialType} onSelect={e => setCredentialType(e)} /> */}
                </div>
                <div className='chart-header-right'>
                    <div className='mr-2'>
                        <CustomDropDown list={['All Documents', 'Issued', 'Draft', 'Revoked']} selectedOption={documentType} onSelect={e => handleDocumentChange(e)} />
                    </div>
                    <CustomDropDown list={['Last 7 days', 'Last 30 days', 'Last 90 days']} selectedOption={timePeriod} onSelect={e => handleTimeChange(e)} />
                </div>

            </div>
            {loading ? <ShimmerLoader height="20rem" /> : <>
                <BarChart
      width={900}
      height={450}
      data={graphData}
      margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      barCategoryGap="20%"
      barGap={4}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />

      <Bar
        dataKey="count"
        fill="#8884d8"
        maxBarSize={100}
        radius={[6, 6, 0, 0]}
      >
        <LabelList dataKey="count" position="top" />
      </Bar>
    </BarChart>
                <span className='chart-y-text'>No. of Documents</span>
            </>}

        </div>

    )
}
